import { CircularProgress, Stack } from "@mui/material"
import { useEffect, useState } from "react"
import { rootStore, useStores } from "stores/root-store"
import { MainComponent, ContentWrapper, AppLoadingContainer } from "components/common-styles"
import { useParams } from "react-router-dom"
import BreadcrumbHeader from "components/common/breadcrumb-header"

import InboundDeliveryInfo from "components/inbound-delivery/details/delivery-info"
import InboundDeliveryProductInfo from "components/inbound-delivery/details/product-info"
import { observer } from "mobx-react-lite"
import InboundDeliveryForm from "components/inbound-delivery/dialog/inbound-delivery-form"

const InboundDeliveryDetail = () => {
  const { receiptId, id } = useParams()

  const { InboundDeliveryStore } = useStores()

  const [openPaperwork, setOpenPaperwork] = useState(false)

  useEffect(() => {
    setOpenPaperwork(false)
    InboundDeliveryStore.loadDetailData(receiptId, id)
  }, [InboundDeliveryStore, receiptId, id, InboundDeliveryStore.forceReload])

  if (InboundDeliveryStore.isLoading || !InboundDeliveryStore.deliveryInfo) {
    return (
      <AppLoadingContainer>
        <CircularProgress size={64} />
      </AppLoadingContainer>
    )
  }

  const onEditClicked = () => {
    rootStore.setOpenForm(true)
  }

  const handleClose = () => {
    rootStore.setOpenForm(false)
    setOpenPaperwork(false)
  }

  const handleSave = () => {
    handleClose()
    InboundDeliveryStore.setForceReload()
  }

  const onPrintClicked = () => {
    rootStore.setOpenForm(true)
    setOpenPaperwork(true)
  }

  if (rootStore.openForm) return <InboundDeliveryForm onlyShowPaperWork={openPaperwork} onSave={handleSave} onClose={handleClose} />

  return (
    <>
      <BreadcrumbHeader />
      <MainComponent component="main">
        <ContentWrapper maxWidth={"xl"}>
          <Stack spacing={2}>
            <InboundDeliveryInfo onEditClicked={onEditClicked} onPrintClicked={onPrintClicked} />
            <InboundDeliveryProductInfo />
          </Stack>
        </ContentWrapper>
      </MainComponent>
    </>
  )
}

export default observer(InboundDeliveryDetail)
